import axios from "axios";
import { ENDPOINT, REQUEST_TIMEOUT } from "./config";

const client = axios.create({
  baseURL: ENDPOINT,
  timeout: REQUEST_TIMEOUT
});

export default client;
